import React from 'react';
import AddressSelect from './CheckoutSearchSelect';

const CheckoutForm = ({ register, setValue, watch, errors }: any) => {
  return (
    <div className="col-lg-7">
      <div className="checkout__details">
        <div className="row g-4">
          <div className="col-12">
            <div className="checkout__title">
              <h5>Checkout</h5>
            </div>
            <div className="checkout__subtitle">
              <p>Billing Details</p>
            </div>
          </div>

          {/* Name Field */}
          <div className="col-12">
            <div className="input-group">
              <input
                {...register('shipping_name', { required: 'Name is required' })}
                className="form-control"
                placeholder="Name*"
              />
            </div>
            {errors.shipping_name && (
              <small className="text-danger">
                {errors.shipping_name.message}
              </small>
            )}
          </div>

          {/* Phone Field */}
          <div className="col-lg-6">
            <div className="input-group">
              <input
                {...register('shipping_phone', {
                  required: 'Phone number is required',
                  pattern: {
                    value: /^01\d{9}$/,
                    message: 'Enter a valid 11-digit Bangladeshi phone number',
                  },
                })}
                className="form-control"
                placeholder="Phone*"
                maxLength={11}
                inputMode="numeric"
              />
            </div>
            {errors.shipping_phone && (
              <small className="text-danger">
                {errors.shipping_phone.message}
              </small>
            )}
          </div>

          {/* Email Field */}
          <div className="col-lg-6">
            <div className="input-group">
              <input
                {...register('email', {
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: 'Enter a valid email address',
                  },
                })}
                className="form-control"
                placeholder="Email address*"
              />
            </div>
            {errors.email && (
              <small className="text-danger">{errors.email.message}</small>
            )}
          </div>

          {/* AddressSelect for area/city/zone */}
          <AddressSelect setValue={setValue} watch={watch} />

          {/* Shipping Address Field */}
          <div className="col-12">
            <div className="input-group">
              <input
                {...register('shipping_address', {
                  required: 'Address is required',
                })}
                className="form-control"
                placeholder="Address"
              />
            </div>
            {errors.shipping_address && (
              <small className="text-danger">
                {errors.shipping_address.message}
              </small>
            )}
          </div>

          {/* Note Field */}
          <div className="col-12">
            <div className="input-group">
              <textarea
                {...register('note')}
                className="form-control"
                rows={4}
                placeholder="Write a message..."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutForm;
